<template>
<compare-time-year @on-years-changed="onYearsChanged" />
</template>

<script>
export default {
  name: 'CompareTimeYearWrapper',
  props: {
    query: {
      required: true,
      type: Object
    }
  },
  methods: {
    onYearsChanged (years) {
      this.years = years
      this.setQuery()
    },
    setQuery () {
      let {years, query} = this

      if (!Array.isArray(years) || years.length === 0) {
        query.queryTimes = []
        this.$emit('select-changed', false)
        return
      }

      query.queryTimes = years.map(year => `${year}年`)

      this.$emit('select-changed', true)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Data/CompareTime/YearWrapper.vue